import React from 'react';
import { Carousel } from "@kursk/components/ui/Carousel/Carousel";
import { CustomButtonGroup } from "@kursk/components/ui/Carousel/Buttons/ButtonGroup";
import _ from "lodash";
import { ImageWithInfo } from "@kursk/components/ui/ImageWithInfo/ImageWithInfo";
import { EntityType } from "@common/redux/types/common";
import { IImage } from "@common/redux/types/images";
import { checkShouldShowEventPlugImage } from "@kursk/utils/showPlug";
import { EventPlugImage } from "@kursk/components/ui/EventPlugImage/EventPlugImage";

import styles from './HeaderBlockImages.module.scss';
import { IHeaderBlockProps } from "../../types/types";
import { OPTIONS, SRC_SET } from "./constants/constants";

type TProps = {
  entityType: EntityType;
  entity: IHeaderBlockProps['entity'];
}

export const HeaderBlockImages = ({ entityType, entity }: TProps) => {
  const image = entity?.image;
  const gallery = 'gallery' in entity ? entity.gallery : [];

  const showEventPlug = checkShouldShowEventPlugImage(entityType, entity);

  const carouselSlides = gallery.length && [image, ...gallery] || [];

  const renderItem = (item: IImage) => (
    <ImageWithInfo
      key={item.name}
      image={item}
      srcSet={SRC_SET}
      useFullscreen
      carouselSlides={carouselSlides}
      className={styles.wrapper}
    />
  );

  return (
    <div className={styles.galleryWrapper}>
      {showEventPlug ? (
        <EventPlugImage />
      ) : carouselSlides.length ? (
        <Carousel
          Buttons={(
            <CustomButtonGroup
              className={styles.carouselButtons}
              buttonClassName={styles.carouselButton}
            />
          )}
          carouselOptions={OPTIONS}
          countable={true}
          countClassStyle={styles.carouselCount}
        >
          {_.map(carouselSlides, renderItem)}
        </Carousel>
      ) : (
        <ImageWithInfo
          className={styles.wrapper}
          image={image}
          srcSet={SRC_SET}
          useFullscreen={true}
        />
      )}
    </div>
  );
};
